import { Form } from 'formik';
import styled from 'styled-components';

import device from 'utils/device';

export const ContentWrapper = styled.div`
  display: flex;
  height: 100%;

  @media ${device.isMobile}, ${device.isTablet} {
    flex-direction: column;
    padding: 20px;
  }
`;

export const ComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
`;

export const FormWrapper = styled(Form)`
  height: 100%;
`;

export const HiddenButton = styled.button`
  width: 1px;
  height: 1px;
  position: absolute;
  top: auto;
  left: -10000px;
  overflow: hidden;
`;
